let env:any = process.env.NODE_ENV;
const appEnv = process.env.VUE_APP_ENV;
if (appEnv) env = appEnv;
class urlConfig {
  public readonly httpRequestUrl: string = '';
  public readonly websocketRequestUrl: string = '';
  public readonly websocketIMModuleRequestUrl: string = '';
  public uploadRequestUrl: string = '';
  public uploadRequestUrlList:Array<string> = [];
  public readonly downloadRequestUrl: string = '';
  public readonly redirectUri: string = '';
  public readonly appid: string = '';
  public appName:string = '课堂派';//应用程序的默认名称
  public readonly imopen:boolean = true;//是否部署im服务
  
  // 地图配置 - 支持百度、高德、腾讯地图
  public mapProvider: 'baidu' | 'amap' | 'tencent' = 'baidu'; // 地图提供商：baidu-百度, amap-高德, tencent-腾讯
  public baiduMapAk:string = '';
  public baiduMapAkList:Array<string> = [];//百度地图的多个AK值
  public amapKey:string = ''; // 高德地图Key（兼容旧配置）
  public amapKeyList:Array<string> = []; // 高德地图多个Key（避免并发限制）
  public amapSecurityJsCode:string = ''; // 高德地图安全密钥
  public tencentMapKey:string = ''; // 腾讯地图Key（兼容旧配置）
  public tencentMapKeyList:Array<string> = []; // 腾讯地图多个Key（避免并发限制）
  
  /**
   * 💰 从key数组中随机选择一个key，避免并发限制
   * @param keyList key数组
   * @param fallbackKey 备用key（兼容旧配置）
   * @returns 随机选择的key
   */
  private getRandomKey(keyList: Array<string>, fallbackKey: string): string {
    // 如果有key数组且不为空，随机选择
    if (keyList && keyList.length > 0) {
      const randomIndex = Math.floor(Math.random() * keyList.length);
      const selectedKey = keyList[randomIndex];
      return selectedKey;
    }
    // 否则使用单个key（兼容旧配置）
    return fallbackKey;
  }
  
  /**
   * 获取高德地图Key（支持随机轮询）
   */
  public getAmapKey(): string {
    return this.getRandomKey(this.amapKeyList, this.amapKey);
  }
  
  /**
   * 获取腾讯地图Key（支持随机轮询）
   */
  public getTencentMapKey(): string {
    return this.getRandomKey(this.tencentMapKeyList, this.tencentMapKey);
  }

  public privateDeploy:boolean = false;//是否是私有部署
  public canRegister:boolean   = true;//是否可以注册
  public showWechatLogin:boolean = true;//是否显示微信登录
  public enableLogCollection:boolean = false;//是否启用日志收集

  constructor(str: string) {
    switch (str) {
      case 'development': {
        this.httpRequestUrl = 'http://ktpdomaincurrent.ketangpai.com';//http://ktpdomain.ketangpai.com
        //this.httpRequestUrl = 'https://testopenapi.webtest.ketangpai.com';
        this.websocketRequestUrl = 'ws://websocket.webtest.ketangpai.com:9200';
        this.uploadRequestUrl = 'https://uploaderv5.webtest.ketangpai.com';
        this.uploadRequestUrlList = [
          'https://uploaderv5.webtest.ketangpai.com',
          'https://uploaderv51.webtest.ketangpai.com',
          'https://uploaderv5.webtest.ketangpai.com',
          'https://uploaderv51.webtest.ketangpai.com',
        ];
        this.downloadRequestUrl = '';
        this.websocketIMModuleRequestUrl = 'wss://im-borker.ketangpai.com:443/ws';
        this.redirectUri = window.location.origin;
        this.appid = 'wxee6b4fab5696d388';
        this.imopen = false;
        // 地图配置
        this.mapProvider = 'amap'; // 可选: 'baidu', 'amap', 'tencent'
        this.baiduMapAk = "";
        this.baiduMapAkList = [];
        
        // 高德地图配置（支持多key轮询，避免并发限制）
        // 高德地图配置（支持多key轮询，避免并发限制）
        this.amapKey = 'fbb8ebb92e9966b94b96624bafa3d077';
        this.amapKeyList = [
        ];
        this.amapSecurityJsCode = '5c0a869c92ef4b8b52495e48259bfda3';
        
        // 腾讯地图配置（支持多key轮询，避免并发限制）
        this.tencentMapKey = 'FLMBZ-XQEC7-467XB-HI6GG-MT4T3-V3FR6';
        this.tencentMapKeyList = [

        ];
        
        this.privateDeploy      = false;//是否是私有部署
        this.canRegister        = false;//是否可以注册
        this.showWechatLogin    = false;//是否显示微信登录
        break;
      }
      case 'test': {
        this.httpRequestUrl = 'https://testopenapi.webtest.ketangpai.com';
        this.websocketRequestUrl = 'ws://websocket.webtest.ketangpai.com:9200';
        this.uploadRequestUrl = 'https://uploaderv5.webtest.ketangpai.com';
        this.uploadRequestUrlList = [
          'https://uploaderv5.webtest.ketangpai.com',
          'https://uploaderv51.webtest.ketangpai.com',
        ];
        this.downloadRequestUrl = '';
        this.websocketIMModuleRequestUrl = 'wss://im.webtest.ketangpai.com:9002/ws';
        this.redirectUri = 'https://testh5.webtest.ketangpai.com';
        this.appid = 'wx0da0b8385e483dcb';
        this.imopen = true;
        // 地图配置
        this.mapProvider = 'baidu'; // 可选: 'baidu', 'amap', 'tencent'
        this.baiduMapAk = "AR6YI9qEHd105hjAByLcHShFHooxnBsR";
        this.baiduMapAkList = [
          "eI8XZ0l5LZWHjbI8EyvRDj2O0CVzrRVr",
          "5Sf2DvFjmDtdPh8XK47ZuGhtnYObsykX",
          "XxT9ViOi0zvuQl9SRUUK3lLtGMxInH02",
          "DcrIfSdclBmPNzonQNTcPCaZDCO3S6p1",
          "r94XxRE6NuWISP81ZGb1EGr6V5OVmAY3",
        ];
        this.amapKey = ''; // 请填写高德地图Key
        this.amapSecurityJsCode = ''; // 请填写高德地图安全密钥
        this.tencentMapKey = ''; // 请填写腾讯地图Key
        break;
      }
      case 'production': {
        this.httpRequestUrl = 'https://openapiv5.ketangpai.com';
        this.websocketRequestUrl = 'wss://websocketv5.ketangpai.com';
        this.uploadRequestUrl = 'https://uploaderv51.ketangpai.com';
        this.uploadRequestUrlList = [
          'https://uploaderv51.ketangpai.com',
          'https://uploaderv52.ketangpai.com',
          'https://uploaderv53.ketangpai.com',
          // 'https://uploaderv53.ketangpai.com',
        ];
        this.downloadRequestUrl = '';
        this.websocketIMModuleRequestUrl = 'wss://im-borker.ketangpai.com:443/ws';
        this.redirectUri = window.location.origin;
        this.appid = 'wxee6b4fab5696d388';
        this.imopen = true;
        // 地图配置
        this.mapProvider = 'amap'; // 可选: 'baidu', 'amap', 'tencent'
        this.baiduMapAk = "";
        this.baiduMapAkList = [];
        
        // 高德地图配置（支持多key轮询，避免并发限制）
        this.amapKey = 'b2e088992fa76030df6e9c36b8d9281a';
        this.amapKeyList = [
        ];
        this.amapSecurityJsCode = 'ef4a5d2661a82525918b3d777f39a8ae';
        
        // 腾讯地图配置（支持多key轮询，避免并发限制）
        this.tencentMapKey = 'FLMBZ-XQEC7-467XB-HI6GG-MT4T3-V3FR6';
        this.tencentMapKeyList = [
        ];
        break;
      }
      case 'preprod': {
        this.httpRequestUrl = 'https://openapiv5.ketangpai.com';
        this.websocketRequestUrl = 'wss://websocketv5.ketangpai.com';
        this.uploadRequestUrl = 'https://uploaderv5.ketangpai.com';
        this.uploadRequestUrlList = [
          'https://uploaderv51.ketangpai.com',
          'https://uploaderv52.ketangpai.com',
          'https://uploaderv53.ketangpai.com',
        ];
        this.downloadRequestUrl = 'http://package.ketangpai.com/';
        this.websocketIMModuleRequestUrl = 'wss://im-borker.ketangpai.com:443/ws';
        this.redirectUri = 'https://preh5.ketangpai.com';
        this.appid = 'wxee6b4fab5696d388';
        this.imopen = true;
        // 地图配置
        this.mapProvider = 'baidu'; // 可选: 'baidu', 'amap', 'tencent'
        this.baiduMapAk = "AR6YI9qEHd105hjAByLcHShFHooxnBsR";
        this.baiduMapAkList = [
          "eI8XZ0l5LZWHjbI8EyvRDj2O0CVzrRVr",
          "5Sf2DvFjmDtdPh8XK47ZuGhtnYObsykX",
          "XxT9ViOi0zvuQl9SRUUK3lLtGMxInH02",
          "DcrIfSdclBmPNzonQNTcPCaZDCO3S6p1",
          "r94XxRE6NuWISP81ZGb1EGr6V5OVmAY3",
        ];
        this.amapKey = ''; // 请填写高德地图Key
        this.amapSecurityJsCode = ''; // 请填写高德地图安全密钥
        this.tencentMapKey = ''; // 请填写腾讯地图Key
        break;
      }
      default: {
        throw new Error(`environment error at setting request url at urlConfig.js, now process.env.NODE_ENV is:${env}`);
      }
    }
    //这里进行随机选择一个AK来使用
    if(this.baiduMapAkList!=undefined && this.baiduMapAkList.length>0){
      let count = this.baiduMapAkList.length;
      if(count>0){
        //随机取出一个
        let randIndex = Math.floor(Math.random()*count);
        let tmp = this.baiduMapAkList[randIndex];
        if(tmp != "" && tmp !=null && tmp.length>0){
          //随机第一个地址出来
          this.baiduMapAk = tmp;
        }
        console.log("baiduMapAk:"+this.baiduMapAk);
      }
    }
  }
}

const urlConfigInstance = new urlConfig(env);

// 学校本地化（K8s）部署：运行时配置覆盖。容器入口按环境变量生成 /ktp-config.js
// 写入 window.__KTP_CONFIG__，实现"一份前端镜像服务所有学校"（不重新构建）。
// SaaS 构建产物不受影响：public/ktp-config.js 默认为空对象，无任何覆盖。
const runtimeOverrides = (window as any).__KTP_CONFIG__;
if (runtimeOverrides && typeof runtimeOverrides === 'object') {
  Object.assign(urlConfigInstance, runtimeOverrides);
}

export default urlConfigInstance;
